import { Injectable, OnApplicationBootstrap } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { RoleEntity } from "../models/role.entity";

@Injectable()
export class RoleDataService implements OnApplicationBootstrap {
  constructor(
    @InjectRepository(RoleEntity)
    private roleRepo: Repository<RoleEntity>
  ) {}

  onApplicationBootstrap() {
      const roles = [
          { id: 1, name: 'anonymous' },
          { id: 2, name: 'logged in' },
          { id: 3, name: 'administrator'}
      ];
      this.roleRepo.save(roles);
  }

}
